import FieldDropdown from "../dropdown/dropdown"

import FieldPriority_PopoverOption from "./components/option/option"
import FieldPriority_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldPriority_PopoverMore from "./components/popover/popover-menu-more"
import FieldPriority_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldConfig from "../../proto/field-config"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldPriority_AutomationTriggerForm from "./render/automation-trigger-form"
import FieldPriority_AutomationConditionForm from "./render/automation-condition-form"
import FieldPriority_QuickFilterView from "./render/quick-filter-view"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import {ConditionType_Excludes, ConditionType_Includes} from "../../../model2/conditions/condition-types"
import FieldPriority_ConditionForm from "./render/condition"
import FieldPriority_GraphTickLabelView from "./render/graph-tick-label"

// @ts-ignore
import d3 from 'd3'
import {ColorPalette, DefaultPaletteColorNumber, ItemColorCoding} from "../../color-coding/color-coding";
import FieldPriority_Editable from "./render/editable/editable";
import FieldPriority_TableCell from "./render/table/table-cell";

const debug = false
// const debug = "FieldPriority"

export default class FieldPriority extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.conditionTypes     = [ConditionType_Includes, ConditionType_Excludes]

        this.typeLabel          = "Priority";
        this.typeGroup          = GROUP_MISC
        this.typeDescription    = "Priority select field"
        this.icon               = 'i5-flag';

        // special
        if (gd.companyId) {
            this.options            = gd.session.companies.get(gd.companyId).priorities.exportToOptions(); // [{value, label, color},...]
        } else {
            console.error("#mmcn99dk no company id... how come")
            this.options = []
        }

        this.noValueOption      = false;

        this.isSearchable       = false;

        _.assign(this.components,{
            PopoverOption       : FieldPriority_PopoverOption,
            PopoverMenuMore     : this.showMenuMore ? FieldPriority_PopoverMore : null,
            FormValueNotEmpty   : FieldPriority_FormValueNotEmpty,
            InlineValueNotEmpty : FieldPriority_InlineValueNotEmpty,
        })

        this.classes.PopoverMenu                        = 'w-200'
        this.classes.PopoverMenuScrollContainer         = 'max-h-275'

        this.renderComponents.automationTriggerForm     = FieldPriority_AutomationTriggerForm
        this.renderComponents.automationConditionForm   = FieldPriority_AutomationConditionForm
        this.renderComponents.conditionForm             = FieldPriority_ConditionForm
        this.renderComponents.quickFilterView           = FieldPriority_QuickFilterView
        this.renderComponents.graphTickLabelView        = FieldPriority_GraphTickLabelView

        this.renderComponents.editable                  = FieldPriority_Editable
        this.renderComponents.tableCell                 = FieldPriority_TableCell
    }

    groupValue(value:any) {
        return _.get(this._getOption(value),'value', value?.toString())
    }

    groupLabel(value:any) {
        // @ts-ignore
        return gd.company.priorities['priority'+value] ? gd.company.priorities['priority'+value] : value?.toString()
    }

    groupSortValue(value: any): null {
        return this.groupValue(value)
    }

    sortValue(value: any): any {
        const priority = _.get(this._getOption(value), 'value', value)
        return !_.isNil(priority) ? -priority : 0
    }

    getGraphColor(model:any|null, params: any) {

        if (!model) return '#FF0000'

        const modelValue = parseInt(_.get(model, this.fieldId, null))

        debug && console.log(debug, 'getGraphColor modelValue', modelValue > 5, modelValue, model)

        if (modelValue) {
            let highPriorityColors = d3.interpolateLab('#ff0000', '#ffb400')
            let lowPriorityColors = d3.interpolateLab('#0096ff', '#003cff')

            let color = '#aaaaaa'
            if (modelValue > 5) {
                const highPriorities = [100,50,10,9,8,7,6]
                const index = _.indexOf(highPriorities, modelValue)
                color = highPriorityColors(index/(highPriorities.length - 1))
            } else if (modelValue < 5) {
                const lowPriorities = [4,3,2,1]
                const index = _.indexOf(lowPriorities, modelValue)
                color = lowPriorityColors(index/(lowPriorities.length - 1))
            }

            debug && console.log(debug, 'getGraphColor', color)

            return color
        }

        return '#0088FE'
    }

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)
        let res = rawValue
        const priorities = gd.company.priorities
        // @ts-ignore
        if (priorities['priority'+rawValue]) res = priorities['priority'+rawValue]
        return res
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        const priorities = gd.company.priorities;

        let intValue

        // Try map by number
        intValue = parseInt(value)
        // @ts-ignore
        if (intValue && priorities.getName(intValue)) {

            // @ts-ignore
            if (priorities["priority"+intValue]) {
                return intValue
            } else {
                return null
            }
        }

        // try map by string
        intValue = priorities.getValueByName(value)
        if (intValue) {
            return intValue
        }

        return null
    }

    getColorCoding(model: any): ItemColorCoding {
        const value     = _.get(model, this.fieldId, null)
        let priority    = _.find(this.options, (option)=>option.value === value)

        if (!priority && this.options && typeof value === 'number') {
            // get closest option
            const allValues         = _.map(this.options, option=>option.value)             // get all options values
            const diffValues        = _.map(allValues, v=>Math.abs(v - value))           // calculate difference between option value and passed value
            const lowestDifference  = _.min(diffValues)                                     // get the lowest difference value
            priority                = this.options[_.indexOf(diffValues, lowestDifference)] // get option according to index of the lowest difference in diffValues
        }

        return {
            colorNumber     : priority?.color || DefaultPaletteColorNumber.PRIORITY,
            corePalette     : ColorPalette.PRIORITY
        }
    }
}